var map = {
	"./already-unsubscribed.svg": 345,
	"./box.svg": 789,
	"./delivery_failed.png": 790,
	"./delivery_in_progress.svg": 346,
	"./delivery_rescheduled.png": 791,
	"./home-back.png": 347,
	"./icons/airline.svg": 792,
	"./icons/box.svg": 793,
	"./icons/clearance.svg": 794,
	"./icons/csv-file-format-extension.svg": 795,
	"./icons/delivery-success.svg": 796,
	"./icons/delivery.svg": 797,
	"./icons/exclamation-circle-solid.svg": 798,
	"./icons/factory.svg": 799,
	"./icons/file-content.svg": 800,
	"./icons/file.svg": 801,
	"./icons/google-drive-pdf-file.svg": 802,
	"./icons/package.svg": 803,
	"./icons/payment-method.svg": 804,
	"./icons/pdf-file-format-symbol.svg": 805,
	"./icons/storage.svg": 806,
	"./icons/warehouse.svg": 807,
	"./intra_destination_transfer.svg": 808,
	"./intra_origin_transfer.svg": 809,
	"./janio-favicon.png": 810,
	"./janio-logo.png": 811,
	"./janio-logo2.png": 337,
	"./janio-main-logo.png": 812,
	"./janio-sticker-logo.png": 813,
	"./janio_big_logo.svg": 348,
	"./janio_logo (no tagline).png": 814,
	"./janio_logo (no tagline).svg": 815,
	"./janio_logo.png": 816,
	"./janio_logo.webp": 817,
	"./janio_old_big_logo.png": 818,
	"./loading.svg": 341,
	"./order-not-found.svg": 349,
	"./order_info_received.png": 819,
	"./order_picked_up.png": 820,
	"./order_received_at_destination_warehouse.png": 821,
	"./order_received_at_local_sorting_center.png": 822,
	"./order_received_by_airline.png": 823,
	"./package.png": 824,
	"./pending_customs_clearance.png": 825,
	"./success.png": 826,
	"./tracker timeline.png": 344,
	"./trolley.svg": 350,
	"./truck-icon.png": 827,
	"./twoGoExpress.png": 828,
	"./unsubscribe_success.svg": 351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;